import { COMP_UPLOAD_UI } from "../constants";
import { UploadComponent } from "./upload";

export class MatchSelectionsBehavior {
  constructor(controller, $container, parent) {
    this.controller = controller;
    this.$container = $container;
    this.parent = parent;
    this._initialized = false;
    this.match_options = false;
    this._busy = false;
  }

  async init() {
    if (this._initialized) {
      return;
    }

    const me = this;
    $("#same_both_ears").change(function () {
      me.match_options = $(this).is(":checked");
    });

    this._initialized = true;
  }

  select_group(layer, name, side) {
    const $groupBtn = this.$container.find(`[data-layer=${layer}][data-side=${side}] .swatch-group-btn[data-name=${name}]`);
    const $cat = $groupBtn.closest('.category-option')


    if (this.match_options) {
        // avoid auto selecting color options so mark cat as has selection so we don't roll into it
      $cat.addClass('has-selection');
      // Cheeky way of auto selecting by clicking on oposite side group
      $groupBtn.click();
      // then close collapse selection in case it opens due to another process
      $cat.addClass('collapsed');
    }
  }

  select_swatch(group, name, side) {
    const $swatch = this.$container.find(`.swatch[data-group=${group}][data-name=${name}][data-side=${side}]`);
    const $cat = $swatch.closest('.category-option')


    if (this.match_options) {
      // avoid auto selecting color options so mark cat as has selection so we don't roll into it
      $cat.addClass('has-selection');
      // Cheeky way of auto selecting by clicking on oposite side swatch
      $swatch.click();
      // then close collapse selection in case it opens due to another process
      $cat.addClass('collapsed');
    }
  }

  async activateSwatchGroup($swatchGroup, updateState) {
    const name = $swatchGroup.attr('data-name');
    const $optionCat = $swatchGroup.closest(".category-option");
    const layer = $optionCat.attr("data-layer");
    const side = $optionCat.attr("data-side");

    // Only activate when selecting the left side
    if (this.match_options && name && layer && side == "left") {
      this.select_group(layer, name, "right");
    }
  }

  async activateSwatch($swatch, matLayers, updateState) {

    const name = $swatch.attr('data-name');
    const group = $swatch.attr('data-group');
    const side = $swatch.attr('data-side');

    // Only activate when selecting the left side
    if (this.match_options && name && group && side == "left") {
      this.select_swatch(group, name, "right")
    }
  }

  async on_image_uploaded(file, url, file_name, hide_editor, apply_material, side, layer) {
    if (this._busy) {
      return;
    }

    const state = this.controller.state;
    if (this.match_options && side == "left") {
      this._busy = true;
      try {
        const swatchController = Array.from(this.controller.optionsControllers["right"].values()).find(s => s.components.has(COMP_UPLOAD_UI));
        const uploadComponent = swatchController.components.get(COMP_UPLOAD_UI);
        await uploadComponent.loadImage(new File([file], file.name, { type: file.type }), url, file_name, true, true);
        uploadComponent.updateImageTransform();
      } finally {
        this._busy = false;
      }
    }

    console.log(state);
  }
}